/**
 * 카카오맵 API가 준비될 때까지 기다리는 함수
 * HTML에 이미 스크립트가 로드되어 있으므로, API가 초기화될 때까지만 기다립니다.
 */

/**
 * 카카오맵 API가 사용 가능할 때까지 기다립니다
 * @returns {Promise} 카카오맵 API가 준비되면 resolve되는 Promise
 */
export function waitForKakaoMapAPI() {
  // 이미 준비되어 있으면 즉시 반환
  if (window.kakao?.maps?.LatLng) {
    return Promise.resolve();
  }

  // API가 준비될 때까지 기다림
  return new Promise((resolve, reject) => {
    let checkCount = 0;
    const maxChecks = 100; // 최대 10초 (100회 * 100ms)

    const checkInterval = setInterval(() => {
      checkCount++;

      // LatLng 생성자가 사용 가능한지 확인
      if (window.kakao?.maps?.LatLng && typeof window.kakao.maps.LatLng === 'function') {
        clearInterval(checkInterval);
        resolve();
      } else if (checkCount >= maxChecks) {
        // 타임아웃
        clearInterval(checkInterval);
        reject(new Error('카카오맵 API를 불러오는데 시간이 너무 오래 걸립니다. 페이지를 새로고침해주세요.'));
      }
    }, 100); // 100ms마다 확인
  });
}
